export const ascendingSort = (key: string) => (a: any, b: any) => {
  if (a[key] < b[key]) {
    return -1;
  }

  if (a[key] > b[key]) {
    return 1;
  }

  return 0;
};

export const sortNumber = (a: any, b: any, key: string, isASC: boolean) => {
  const A = parseFloat(`${a[key]}`.replace(/,/g, ''));
  const B = parseFloat(`${b[key]}`.replace(/,/g, ''));

  if (isASC) return A - B;
  else return B - A;
};

export const sortString = (a: any, b: any, key: string, isASC: boolean) => {
  const A = `${a[key]}`.toLowerCase();
  const B = `${b[key]}`.toLowerCase();

  if (isASC ? A < B : B < A) {
    return -1;
  } else if (isASC ? A > B : B > A) {
    return 1;
  }
  return 0;
};

export const splitArray = (array, chunkSize = 90) => {
  const chunks = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    chunks.push(chunk);
  }
  return chunks;
};

export const sortObject = (
  obj: Record<string, any>,
): { [key: string]: any } => {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
};

export function chunkArray(array: any, size: number) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

/**
 * Sorts an array of month/value objects chronologically (oldest → newest).
 *
 * @param arr - Array of objects containing a `month` field (e.g. "September 2025").
 * @returns A new array sorted from oldest to newest month.
 */
export const sortChronologically = <T extends { month: string }>(
  arr: T[],
): T[] => {
  return [...arr].sort(
    (a, b) => new Date(a.month).getTime() - new Date(b.month).getTime(),
  );
};
